import React, { useEffect } from 'react';
import { AuthProvider } from './context/AuthContext';
import AppRouter from './Router';
import './App.css';

/** WebKit standalone often paints a blank WKWebView after returning from Safari. */
function RecoverStandaloneRepaint() {
  const root = document.getElementById('root');
  if (!root) return;
  const prev = root.style.display;
  root.style.display = 'none';
  void root.offsetHeight;
  root.style.display = prev;
}

function App() {
  useEffect(() => {
    let wasHidden = document.visibilityState === 'hidden';

    const KickRepaint = () => {
      requestAnimationFrame(() => {
        requestAnimationFrame(RecoverStandaloneRepaint);
      });
    };

    const OnVisibility = () => {
      if (document.visibilityState === 'hidden') {
        wasHidden = true;
        return;
      }
      if (!wasHidden) return;
      wasHidden = false;
      KickRepaint();
    };

    const OnPageShow = (event) => {
      if (event.persisted || wasHidden) {
        wasHidden = false;
        KickRepaint();
      }
    };

    document.addEventListener('visibilitychange', OnVisibility);
    window.addEventListener('pageshow', OnPageShow);
    return () => {
      document.removeEventListener('visibilitychange', OnVisibility);
      window.removeEventListener('pageshow', OnPageShow);
    };
  }, []);

  return (
    <AuthProvider>
      <AppRouter />
    </AuthProvider>
  );
}

export default App;
